import {html, css, LitElement} from 'lit';

export class DzFilterSpoiler extends LitElement {
    static properties = {
        closed:   {type: Boolean},
        limit:  {type: Number}
    }

    constructor() {
        super()
        this.limit = 7
        this.closed = false
    }

    render() {
        let result = []
        let header = this.querySelector("*[slot=header]").cloneNode(true)
        let arrow = null
        if (this.closed) {
            arrow = html`
                <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.984864 1.73902L4.37497 5.12913L0.984863 8.52663L2.02854 9.57031L6.46973 5.12913L2.02854 0.687942L0.984864 1.73902Z" fill="#C1C1C1"/>
                </svg>
            `
        } else {
            arrow = html`
                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.11742 0.312011L4.72732 3.70212L1.32981 0.312012L0.286133 1.35569L4.72732 5.79687L9.1685 1.35569L8.11742 0.312011Z" fill="#C1C1C1"/>
                </svg>
            `
        }

        result.push(html`<div part="${this.closed ? 'header-closed' : 'header'}" @click="${this.setState}">${arrow}${header}</div>`)

        let body = []
        for (let item of this.querySelector("*[slot=body]").children) {
            body.push(html`<div part="item-row"><input type="checkbox" part="item-checkbox" />${item.cloneNode(true)}</div>`)
        }
        result.push(html`<div part="body" style="height: ${this.closed ? "0px": "auto"}">${body}</div>`) 
        return result
    }

    setState() {
        if (!this.closed) {
            this.closed = true
        } else {
            this.closed = false
        }
    }

    static styles = css`
        *[part=body] {
            overflow: hidden;
            transition: 0.5s;
        }

        *[part=header],
        *[part=header-closed] {
            align-items: center;
            display: grid;
            grid-template-columns: 20px 1fr;
        }

    `
}

customElements.define('dz-filter-spoiler', DzFilterSpoiler);